<script setup>
import { useField } from "vee-validate";
import { computed } from "vue";

import { BaseFormGroup } from "@/shared";

import importedProps from "../config/inputProps";

const props = defineProps({ ...importedProps });

const { value, errorMessage, handleChange, handleBlur, meta } = useField(
    () => props.name,
    undefined,
    {
        syncVModel: true,
    }
);

const isError = computed(() => (meta.touched && !meta.valid) || props.isError);
</script>

<template>
    <BaseFormGroup
        class="validate-input"
        v-bind="props"
        v-model="value"
        :is-error="isError"
        @change="handleChange"
        @blur="handleBlur"
    >
        <template #additional>
            <span class="validate-input__error" v-if="isError">
                {{ errorMessage }}
            </span>
            <slot name="additional" />
        </template>
    </BaseFormGroup>
</template>

<style lang="scss" scoped>
.validate-input__error {
    color: var(--input-color-error);
}
</style>
